import Router from 'vue-router'
import Index from '@/pages/index'
import book from './book'
import user from './user';
import course from './course';

export default [{
    path: '/',
    name: 'index',
    component: Index,
    meta: {
      title: '首页',
      navIndex: 0,
      bgColor: '#fff'
    }
  },
  {
    path: '/introduction',
    name: 'introduction',
    component: () => import('pages/introduction'),
    meta: {
      title: '功能介绍'
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('pages/about'),
    meta: {
      title: '关于我们'
    }
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('pages/test'),
    meta: {
      title: ''
    }
  },
  ...book,
  ...user,
  ...course,
]